import { CommonModule } from '@angular/common';
import { ScrollService } from '../../services/scroll.service';
import { Component, OnInit, OnDestroy,HostListener } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  menuOpen = false;
  scrolled = false; // Ahora se controla desde el servicio
  private scrollSubscription!: Subscription;

  constructor(private scrollService: ScrollService) {}

  ngOnInit() {
    // Suscribirse a los cambios del estado "scrolled"
    this.scrollSubscription = this.scrollService.scrolled$.subscribe(
      (isScrolled) => {
        this.scrolled = isScrolled;
      }
    );
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  // Eliminar la suscripción para evitar memory leaks
  ngOnDestroy() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Solo reaccionar al scroll si no está forzado por otro componente
    if (!this.scrolled) {
      const isScrolled = window.scrollY > 10;
      this.scrollService.setScrolled(isScrolled);
    }
  }
  
}
